import { jsx as _jsx } from "react/jsx-runtime";
import { getMember, isMemberSignedIn, LoadingState, loadMember } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useLoadAction } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { MemberContextMessage, MemberContextMessageType } from './subcomponents/message';
import { MemberContextInstance } from './types/context';
import { defaultMemberContextProps, memberContextPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-context');
const MemberContext = observer(props => {
    const { displayText, assets } = props;
    const isSignedIn = isMemberSignedIn();
    const loadAction = useCallback(() => {
        if (isSignedIn)
            return loadMember();
    }, [isSignedIn]);
    const { loadingState, reload } = useLoadAction(loadAction);
    if (!isSignedIn)
        return null;
    if (loadingState === LoadingState.Failure) {
        return (_jsx(MemberContextMessage, { messageType: MemberContextMessageType.FailedToLoadData, displayText: displayText, assets: assets, onRetryButtonClick: reload }));
    }
    const member = getMember();
    return (_jsx(MemberContextInstance.Provider, Object.assign({ value: { member } }, { children: _jsx("div", Object.assign({ className: b.block({ loading: loadingState === LoadingState.Loading }) }, { children: props.children })) })));
});
MemberContext.displayName = 'MemberContext';
/**
 * The **Member Context** component loads the member details from the API and provides it to its children via the `MemberContextInstance`.
 *
 * It will render a single error message with a retry button if the member fails to load, and nothing at all if there is no member currently signed in.
 */
export const MemberContextComponent = withComponentWrapper(MemberContext, defaultMemberContextProps, memberContextPropsValidator);
